import * as Config from '../config';
import { useContext } from "react";
import { ReactReduxContext } from 'react-redux';
// import { useHistory } from "react-router-dom";

import useGetFromApiSearch from './useGetFromApiSearch';
import { setSelectedItems, addDragItems } from "../actions/index";

const useSearchPlaylists = (id, pathApi, perPage = 100, type = 'CHART') => {
  const [response] = useGetFromApiSearch(id, pathApi, false, `playlists`, perPage);
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;
  const state = store.getState();
  let result = (response) ? { ...response } : null;
  // let globalHistory = useHistory();

  const dragMore = (items, next) => {
    const req = (next.includes(`https`)) ? state.api.getFromURL(next) : state.api.getFromApi(next, false);
    req.then( response => {
      const newItems = [...items, ...response.data.results.map(Config.formattedFromBP)];
      if (response.data.next) {
        dragMore(newItems, response.data.next);
      } else {
        dispatch(setSelectedItems(newItems));
        dispatch(addDragItems());
      }
    } ).catch( e => console.log(`error`, e) );
  }

  const beginDrag = (id) => {
    return () => {
      dragMore([], `/v4/catalog/charts/${id}/tracks/?per_page=100`);
    }
  }

  const resizeImg = (url) => url.replace(`500x500`, `200x200`).replace(`1400x1400`, `200x200`);

  const format = x => ({
    id: x.chart_id,
    title: x.chart_name,
    artists: (x.artist_id) ? [{
      id: x.artist_id,
      name: x.artist_name,
      slug: Config.formatSlug(x.artist_name)
    }] : ( x.person_id ? [{
      id: x.person_id,
      name: x.person_username,
      slug: Config.formatSlug(x.person_username)
    }] : [] ),
    artists_s: (x.artist_id) ? x.artist_name : ( x.person_id ? x.person_username : 'DJ UNKNOW`'),
    img: (x.chart_image_uri && x.chart_image_uri !== Config.DEFAULT_IMG) ? resizeImg(x.chart_image_uri) : Config.DEFAULT_IMG,
    images: [(x.chart_image_uri && x.chart_image_uri !== Config.DEFAULT_IMG) ? resizeImg(x.chart_image_uri) : Config.DEFAULT_IMG],
    audio: { //USED BY THE SOURCE D&D
      id: x.chart_id,
      name: x.chart_name,
      tracks: x.track_count,
      uri: `/charts/${x.chart_id}`,
      parentPathApi: pathApi,
      artists_s: (x.artist_id) ? x.artist_name : ( x.person_id ? x.person_username : 'DJ UNKNOW'),
      extra: {
        covers: [(x.chart_image_uri && x.chart_image_uri !== Config.DEFAULT_IMG) ? resizeImg(x.chart_image_uri) : Config.DEFAULT_IMG],
        fromDJ: (x.artist_id) ? x.artist_name : ( x.person_id ? x.person_username : null),
        fromDJID: (x.artist_id) ? x.artist_id : null
      }
    },
    tracks: x.track_count,
    type,
    dragEnabled: true,
    playEnabled: false,
    beginDrag: beginDrag(x.chart_id),
    isActive: null // (globalHistory.location.pathname === `/charts/${x.chart_id}`) - DEAD CODE
  });

  if (response) {
    result.items = (response.items) ? response.items.map(format) : null;
  }

  return [result];
};

export default useSearchPlaylists;
